import React, { memo } from 'react'

import { relogio } from '../../../utils/alternanciaIcones'
import * as S from '../styles'

const PERFIL_IMG =
  'https://jazzaero.com.br/wp-content/uploads/2017/05/default-placeholder-profile-icon-avatar-gray-woman-90197997.jpg'

const ALLOW_VIDEO =
  'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'

/**
 * @param {Object} props.video
 * @param {Function} props.onLoad
 */
function VideoCard({ video, onLoad }) {
  return (
    <S.VideoWrapper>
      <S.ContainerVideo>
        <S.VideoIframe
          loading="eager"
          src={video.ds_url}
          allow={ALLOW_VIDEO}
          allowFullScreen
          title={video.ds_titulo}
          onLoad={onLoad}
        />
      </S.ContainerVideo>
      <S.ContainerDetalhesVideo>
        <S.ContainerDescricaoVideo>
          <S.TituloVideo>{video.ds_titulo}</S.TituloVideo>
          <S.DescricaoVideo>{video.ds_descricao}</S.DescricaoVideo>
        </S.ContainerDescricaoVideo>

        <S.Divisoria />

        <S.ContainerDetalhes>
          <S.ContainerUploaderVideo>
            <S.ContainerFoto>
              <S.FotoVideo src={PERFIL_IMG} alt="perfil" />
            </S.ContainerFoto>
            <S.ContainerApresentador>
              <S.NomeApresentador>
                {video.ds_nome_apresentador}
              </S.NomeApresentador>
            </S.ContainerApresentador>
          </S.ContainerUploaderVideo>
          <S.ContainerTempo>
            <S.IconeRelogioVideo src={relogio()} alt="tempo" />
            <S.TempoVideo>{video.tm_tempo_video}</S.TempoVideo>
          </S.ContainerTempo>
        </S.ContainerDetalhes>
      </S.ContainerDetalhesVideo>
    </S.VideoWrapper>
  )
}

export default memo(VideoCard)
